import { useState } from "react";


export const SearchBar = ({ selectKey, categories, defVal, incAll }) => {

    const [defaultVal, setDefaultVal] = useState(defVal);

    const handleSelect = (keyword) => {
        selectKey(keyword);
    } 

    return (
        <div className="search-input-box" style={{ marginBlock: 16 }}>
            <img 
                src="/svgs/filter.svg" 
                alt="" 
                width={24} 
                 className="search-icon" 
            />
            <select
                onChange={(e) => {
                    e.preventDefault();
                   handleSelect(e.target.value)
                }}
                className="search-input"
                style={{
                    width: 300,
                    maxWidth: '90%',
                }}
            >
               <option defaultValue={null || defVal }>{defVal || "Filter select by field of study"}</option>
                {incAll && <option value={null}>{"All"}</option>}
                {categories.map((category) => (
                    <option value={category}>{category}</option>
                ))}
            </select>
        </div>
    )
}